export enum DataFilterOperationType {
  And = 'and',
  Or = 'or',
}

